import React from 'react';

type LayoutType = 'inline' | 'responsive' | 'tableLineBreak' | 'tableResponsive';

type Props = Readonly<{
    value: string | null;
    layout?: LayoutType;
}>;

const LAYOUT_TYPES: { [key in LayoutType]: [string, string] } = {
    inline: ['', ''],
    responsive: ['d-sm-none', 'd-none d-sm-inline'],
    tableLineBreak: ['d-sm-none d-md-inline', 'd-none d-sm-inline d-md-none'],
    tableResponsive: ['d-sm-none d-md-inline d-lg-none', 'd-none d-sm-inline d-md-none d-lg-inline'],
};

function DrawName({ value, layout = 'responsive' }: Props) {
    if (!value?.length) {
        return null;
    }

    const layoutClasses = LAYOUT_TYPES[layout] ?? LAYOUT_TYPES.responsive;

    return (
        <>
            <strong className="font-weight-bolder">{value}</strong>
            <br className={layoutClasses[0]} />
            <span className={layoutClasses[1]}> &ndash; </span>
        </>
    );
}

export default DrawName;
